// The Hugeicons (stroke rounded) glyphs the site uses. Named imports keep the bundle to these
// icons only, rendered as inline SVG by <AppIcon> instead of loading the whole icon font.
import {
  Add01Icon,
  ArrowDown01Icon,
  ArrowRight02Icon,
  Briefcase01Icon,
  ChartIncreaseIcon,
  ColorsIcon,
  Facebook01Icon,
  Globe02Icon,
  Image01Icon,
  InstagramIcon,
  LaptopIcon,
  Linkedin01Icon,
  Menu09Icon,
  MultiplicationSignIcon,
  PenTool03Icon,
  PolygonIcon,
  Rocket01Icon,
  SmartPhone01Icon,
  Target02Icon,
  TiktokIcon,
  UserGroupIcon,
  ViewIcon,
} from '@hugeicons/core-free-icons'

export type IconNode = readonly (readonly [string, Record<string, string | number>])[]

export const icons: Record<string, IconNode> = {
  'add-01': Add01Icon,
  'arrow-down-01': ArrowDown01Icon,
  'arrow-right-02': ArrowRight02Icon,
  'briefcase-01': Briefcase01Icon,
  'chart-increase': ChartIncreaseIcon,
  colors: ColorsIcon,
  'facebook-01': Facebook01Icon,
  'globe-02': Globe02Icon,
  'image-01': Image01Icon,
  instagram: InstagramIcon,
  laptop: LaptopIcon,
  'linkedin-01': Linkedin01Icon,
  'menu-09': Menu09Icon,
  'multiplication-sign': MultiplicationSignIcon,
  'pen-tool-03': PenTool03Icon,
  polygon: PolygonIcon,
  'rocket-01': Rocket01Icon,
  'smart-phone-01': SmartPhone01Icon,
  'target-02': Target02Icon,
  tiktok: TiktokIcon,
  'user-group': UserGroupIcon,
  view: ViewIcon,
}
